import { type UseQueryOptions, keepPreviousData, queryOptions } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { type SignedUrl } from "@/lib/backend/api";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const FILE_QUERY_KEY = "file" as const;

export type SignedKeyQueryOptions = (
  params: Parameters<typeof api.file.getUserUrl>,
) => UseQueryOptions<SignedUrl>;

export const queryOptions_signed_key_user = (params: Parameters<typeof api.file.getUserUrl>) =>
  queryOptions({
    queryKey: [FILE_QUERY_KEY, "user", ...params] as const,
    queryFn: () => extractionWrapper(api.file.getUserUrl(...params)),
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: keepPreviousData,
  });
